"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _providerComponents = require("@kyruus/provider-components");
var _intl = require("@kyruus/intl");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _configUtils = require("../../lib/configUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const proptypes = {
  /** The appointment query to display purpose and relationship, as well as visit-type related things */
  appointmentQuery: (0, _propTypes.shape)({
    patientRel: _propTypes.string,
    purpose: (0, _propTypes.shape)({
      name: _propTypes.string,
      visit_method: _propTypes.string
    })
  }).isRequired,
  /** The config object for the customer */
  config: _propTypes.object.isRequired,
  /** Boolean for whether the alt providers should be shown */
  isOnAltProvidersStep: _propTypes.bool.isRequired,
  /** The provider to display in the sidebar */
  provider: _propTypes.object.isRequired,
  /** The appointment slots to display time data for */
  selectedAppointment: _propTypes.object.isRequired,
  /** The state machine of the current page  */
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  /** Tracking function */
  track: _propTypes.func.isRequired
};
function Sidebar(_ref) {
  let {
    appointmentQuery,
    config,
    isOnAltProvidersStep,
    provider,
    selectedAppointment,
    service,
    track
  } = _ref;
  const [state] = (0, _react2.useService)(service);
  const {
    altProviders,
    services
  } = state.context;
  const detailedAltProviders = (0, _react.useMemo)(() => {
    if (!altProviders) {
      return [];
    }
    return (0, _map.default)(altProviders).call(altProviders, providerResult => {
      return {
        availability: providerResult.availability,
        config,
        location: providerResult.locations[0],
        provider: providerResult.provider
      };
    });
  }, [altProviders, config]);

  // Show the alt providers if we are on a step that should show them and we have any detailedAltProviders.
  // detailedAltProviders will be empty if we aren't on a step with a machine that supports them or if the callback either errors or returns no results.
  const showAltProviders = isOnAltProvidersStep && detailedAltProviders.length > 0;
  const showSchedulingHelpBanner = !(0, _configUtils.shouldHideSchedulingHelpMessages)(config);
  if (!provider) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_styles.SidebarContainer, null, /*#__PURE__*/_react.default.createElement(_styles.SidebarContent, null, /*#__PURE__*/_react.default.createElement(_providerComponents.ProviderSidebar, {
    appointmentQuery: appointmentQuery,
    locations: provider && provider.locations,
    selectedAppointment: selectedAppointment,
    provider: provider,
    showApptTime: true,
    showSchedulingHelpBanner: showSchedulingHelpBanner
  }), showAltProviders === true && /*#__PURE__*/_react.default.createElement(_styles.AltProvidersContainer, {
    "data-testid": "dbw-alt-providers"
  }, /*#__PURE__*/_react.default.createElement(_styles.AltProvidersHeader, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.altProvidersHeader)), /*#__PURE__*/_react.default.createElement(_providerComponents.MiniProviderCardList, {
    createAvailabilityUrl: services.createAvailabilityUrl,
    createProviderUrl: services.createProviderUrl,
    providers: detailedAltProviders,
    track: track
  }))));
}
Sidebar.propTypes = proptypes;
var _default = exports.default = Sidebar;
Sidebar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Sidebar",
  "props": {
    "appointmentQuery": {
      "description": "The appointment query to display purpose and relationship, as well as visit-type related things",
      "type": {
        "name": "shape",
        "value": {
          "patientRel": {
            "name": "string",
            "required": false
          },
          "purpose": {
            "name": "shape",
            "value": {
              "name": {
                "name": "string",
                "required": false
              },
              "visit_method": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": true
    },
    "config": {
      "description": "The config object for the customer",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "isOnAltProvidersStep": {
      "description": "Boolean for whether the alt providers should be shown",
      "type": {
        "name": "bool"
      },
      "required": true
    },
    "provider": {
      "description": "The provider to display in the sidebar",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "selectedAppointment": {
      "description": "The appointment slots to display time data for",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "service": {
      "description": "The state machine of the current page",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "track": {
      "description": "Tracking function",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};